

// INSERT THESE LINKS INTO PAGE
//<a href="#" data-youtubevideoid="dVkWvdm5gBk">

// CONVERT LINKS

var ytLinks = document.querySelectorAll('[data-youtubevideoid]');
if (ytLinks.length > 0) {
    for (var i = 0; i < ytLinks.length; i++) {
        var ytid = ytLinks[i].dataset.youtubevideoid;
        console.log('ytid: ' + ytid);
        ytLinks[i].onclick = function (event) { ShowVideo(event, ytid); return false; };
    }
}

// SHOW VIDEO

var yt = document.getElementById("ytVideoWrapper");
function ShowVideo(event, id) {
    event.preventDefault();
    yt.innerHTML =
"<div class='ytinner'>" +
    "<iframe src='https://www.youtube.com/embed/" + id + "?rel=0&showinfo=0&autoplay=1' frameborder='0' allowfullscreen></iframe>" +
    "<a href='#' id='ytclose' class='ytclose' title='close' onclick='CloseYTVideo(); return false;'></a>" +
"</div>"
;
    yt.className = "displaytransition";
    document.documentElement.style.overflow = 'hidden';  // firefox, chrome
    document.body.scroll = "no"; // ie only
}

// HIDE VIDEO

yt.style.cursor = 'pointer';
yt.onclick = function () {
    CloseYTVideo();
};

function CloseYTVideo() {
    yt.className = "hidetransition";
    yt.innerHTML = "";
    document.documentElement.style.overflow = 'auto';  // firefox, chrome
    document.body.scroll = "yes"; // ie only
}